module.exports = __webpack_public_path__ + "img/nurole-text.191c251.svg";